import { createContext, useContext, useRef } from "react";

export const TitleCards = createContext();

export function TitleCardProvider({ children }) {
  const profile = useRef(null);
  const project = useRef(null);
  const contact = useRef(null);

  return (
    <TitleCards.Provider value={{ profile, project, contact }}>
      {children}
    </TitleCards.Provider>
  );
}

export function useTitleCardPos() {
  return useContext(TitleCards);
}